"use client";
import {useState} from "react";
import CWFButton from "@/components/ui/CWFButton";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import TimePicker from "@/components/Calendar/TimePicker";
import {FaClock} from "react-icons/fa";

export default function ReservationModal({profile, offer, userIsLoggedIn}) {
    const [isOpen, setIsOpen] = useState(false);


    return(
        <>
            {userIsLoggedIn && (
                <CWFButton onClick={() => setIsOpen(true)} disabled={!profile.availability || !profile?.profile.hourly_rate}>Réserver</CWFButton>
            )}
            <CWFResponsiveDialog trigger={null} className={"!max-w-4xl"} modalLarge={true}>
                <div className={"grid md:grid-cols-3 "}>
                    <div className={"w-full"}>
                        <h2 className={"text-primary font-semibold text-lg"}>{offer.title}</h2>
                        <p className={"flex items-center gap-x-1 text-sm italic"}><FaClock/>{offer.time} minutes</p>
                        <div className={"flex justify-center gap-x-1 w-full"}>
                            <img src={offer.document?.path || '/imagedefault.png'} height={60} width={60}
                                 className={"w-48 h-48 object-contain"}/>
                        </div>

                        <p className={"whitespace-pre-line pt-5"}>{offer.description}</p>
                    </div>
                    <div className={"md:col-span-2"}>
                        {profile.availability && (
                            <TimePicker bookingTimes={JSON.parse(profile.availability.availabilities)} length={offer.time} offerId={offer.id} userId={profile.id} profile={profile}/>
                        )}
                    </div>

                </div>
            </CWFResponsiveDialog>
        </>
    )
}